import _ from 'lodash';

function formatPhoneNumber(phoneNumber) {
  const phonePrefix = _.slice(phoneNumber, 0, 3);
  const phoneDigits = _.slice(phoneNumber, 3);
  return `${_.join(phonePrefix, '')}-${_.join(phoneDigits, '')}`;
}
function validatePhoneNumber(phoneNumber) {
  return phoneNumber.length === 10;
}

export default {
  formatPhoneNumber,
  validatePhoneNumber,
};
